/**
 * 屏幕与叠加层的 **id 常量**。
 *
 * 用常量而不是到处写字符串字面量：屏幕 id 会同时出现在
 * "注册工厂"、"跳转"、"叠加层判断"三处，写错一个字符的表现是
 * **点下去毫无反应**（或者抛"没有注册过这个屏幕"），很难一眼看出。
 */

export const SCREEN = {
  title: 'title',
  meetup: 'meetup',
  connecting: 'connecting',
  room: 'room',
  /** 热座：本地一桌（和联机对局分开，见 ui/router.ts） */
  hotseat: 'hotseat',
  game: 'game',
  credit: 'credit',
  changelog: 'changelog',
} as const;

export const OVERLAY = {
  settings: 'settings',
} as const;

export type ScreenName = (typeof SCREEN)[keyof typeof SCREEN];
export type OverlayName = (typeof OVERLAY)[keyof typeof OVERLAY];
